package com.essntl.features.travelagent.data.supabase

import com.essntl.features.travelagent.domain.model.TravelAgentModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonNull
import kotlinx.serialization.json.JsonPrimitive

internal fun TravelAgentModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    jobTitle?.let { requestMap["job_title"] = JsonPrimitive(it) }

    source?.let { requestMap["source"] = JsonPrimitive(it) }

    commission?.let { requestMap["commission"] = JsonPrimitive(it) }

    commissionType?.let {
        commissionType -> requestMap["commission_type"] = JsonPrimitive(commissionType.toDto())
        if (commissionType == TravelAgentModel.CommissionType.Net) {
            requestMap["commission"] = JsonNull
        }
    }

    qbCustomerId?.let { requestMap["qb_customer_id"] = JsonPrimitive(it) }

    contact?.let { requestMap["contact_id"] = JsonPrimitive(it.id) }

    return requestMap
}